const postcodeRegExp = /^\s*([A-Z]{1,2}[0-9R][0-9A-Z]?)\s*([0-9][ABD-HJLNP-UW-Z]{2})\s*$/i;

export const isPostcode = ( postcode, trim=false ) => {
    return postcodeRegExp.test( trim ? postcode.trim() : postcode );
};

export const formatPostcode = ( postcode ) => {
    const parts = postcodeRegExp.exec(postcode);
    return parts ? `${parts[1]} ${parts[2]}`.toUpperCase() : null ;
};
